import {
  $getNodeByKey,
  createCommand,
  LexicalCommand,
  LexicalNode,
} from 'lexical'
import { useCallback, useState } from 'react'
import { NodeEventPlugin } from '@lexical/react/LexicalNodeEventPlugin'
import { $isAutoLinkNode, AutoLinkNode } from '@lexical/link'
import { AutoLinkEditor } from '../autoLinkEditor/autoLinkEditor'

export const INSERT_LINK_COMMAND: LexicalCommand<string> = createCommand(
  'INSERT_LINK_COMMAND'
)

export function AutoLinkEditorPlugin(): JSX.Element | null {
  const [isEditorOpened, setIsEditorOpened] = useState(false)
  const [anchorNode, setAnchorNode] = useState<LexicalNode | undefined>(
    undefined
  )
  const [anchorElement, setAnchorElement] = useState<Element | undefined>(
    undefined
  )
  const [url, setUrl] = useState<string>('https://')

  const closeEditor = useCallback(() => {
    setIsEditorOpened(false)
  }, [])

  return (
    <>
      <NodeEventPlugin
        // NodeEventPlugin側でeditor.update()内で呼ばれる
        eventListener={(e, _editor, nodeKey) => {
          console.log('AutoLinkEditorPlugin eventListener', e.target, nodeKey)

          const node = $getNodeByKey(nodeKey)

          if ($isAutoLinkNode(node)) {
            console.log(
              'AutoLinkEditorPlugin AutoLinkNode Click',
              node,
              node.getURL()
            )
            setAnchorNode(node)

            // 表示位置はLinkNodeの位置でよい
            setAnchorElement(undefined)

            setUrl(node.getURL())
            setIsEditorOpened(true)
          }
        }}
        eventType="click"
        nodeType={AutoLinkNode}
      />

      {anchorNode && (
        <AutoLinkEditor
          isOpen={isEditorOpened}
          anchorNode={anchorNode}
          anchorElement={anchorElement}
          url={url}
          onClose={closeEditor}
        />
      )}
    </>
  )
}
